import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { handleApiError } from "../handleApiError";
import i18n from "../../i18n";

const API_URL = process.env.REACT_APP_API_URL_MEDIA_UPLOAD;

// GET ALL MEDIA
export const getMedia = createAsyncThunk(
  "media/getAll",
  async ({ type, page = 1, limit, search = "" }, { rejectWithValue }) => {
    try {
      let url = "";
      const query = new URLSearchParams();
      query.append("page", page);
      query.append("limit", limit);
      // query.append("sort", "-createdAt");

      switch (type) {
        case "images":
          if (search) query.append("search", search);
          // query.append("fields", "id,originalName,url,size,tags,createdAt");
          url = `${API_URL}/images?${query.toString()}`;
          break;
        case "videos":
          if (search) query.append("search", search);
          // query.append("size[lte]", 100000000);
          url = `${API_URL}/videos?${query.toString()}`;
          break;
        case "documents":
          if (search) query.append("search", search);
          // query.append("mimeType[contains]", "pdf");
          url = `${API_URL}/documents?${query.toString()}`;
          break;
        default:
          throw new Error("Invalid media type");
      }

      const response = await axios.get(url);
      // console.log(response);
      return { type, data: response };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ADD / UPLOAD MEDIA
export const addMedia = createAsyncThunk(
  "media/add",
  async ({ type, file, title }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("files", file);
      formData.append("title", title || file.name);

      let url = "";
      switch (type) {
        case "images":
          url = `${API_URL}/images/upload`;
          break;
        case "videos":
          url = `${API_URL}/videos/upload`;
          break;
        case "documents":
          url = `${API_URL}/documents/upload`;
          break;
        default:
          throw new Error("Invalid media type");
      }

      const response = await axios.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      // console.log(i18n.t("common.uploaded"));
      toast.success(
        i18n.t("common.uploaded", { type: i18n.t(`mediaTypes.${type}`) }),
        { autoClose: 3000 },
      );
      return {
        type,
        data: response.data,
        url: response.data.url || response.data[0]?.url,
      };
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data);
    }
  },
);

// DELETE MEDIA
export const deleteMedia = createAsyncThunk(
  "media/delete",
  async ({ type, id }, { rejectWithValue }) => {
    try {
      let url = "";
      switch (type) {
        case "images":
          url = `${API_URL}/images/${id}`;
          break;
        case "videos":
          url = `${API_URL}/videos/${id}`;
          break;
        case "documents":
          url = `${API_URL}/documents/${id}`;
          break;
        default:
          throw new Error("Invalid media type");
      }

      await axios.delete(url);
      toast.success(
        i18n.t("common.deleted", { type: i18n.t(`mediaTypes.${type}`) }),
        { autoClose: 3000 },
      );
      return { type, id };
    } catch (error) {
      toast.error(
        i18n.t("common.deleteFailed", { type: i18n.t(`mediaTypes.${type}`) }),
        { autoClose: 3000 },
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
